import {getDistrict} from "../../utils/SchoolBlocksUtilities";
import {useContext, useEffect, useRef, useState} from "react";
import {StoreContext} from "../../stores/StoreLoader";
import styles from './styles/WebAppInstallPrompt.module.scss';
import FontAwesome from "../utilities/FontAwesome";
import ClickableLink from "../utilities/ClickableLink";
import classNames from 'classnames';
import {getCookieFromString, setCookie} from "../../utils/StringUtilities";

const cookieKey = "webapp";

export function WebAppInstallPrompt(props) {
    const {organizationStore, interfaceStore, modalStore} = useContext(StoreContext);

    // iOS doesn't support web app downloads, but if it's Safari we can instruct how to add to homescreen
    const isIosSafari = /(iPod|iPhone)/.exec(interfaceStore.userAgent) && /Safari/.exec(interfaceStore.userAgent);

    const [showAlert, setShowAlert] = useState(false);
    const deferredPrompt = useRef<BeforeInstallPromptEvent | null>(null);

    function handleInstallPrompt(e) {
        deferredPrompt.current = e;
        if (
            interfaceStore.breakpoint === "break-point-xs" &&
            !(
                window.matchMedia('(display-mode: minimal-ui)').matches ||
                window.matchMedia('(display-mode: standalone)').matches // maybe when added to homescreen on iOS?
            ) &&
            !getCookieFromString(cookieKey, document.cookie)
        ) {
            // only show prompt on small screens
            setShowAlert(true);
        }
    }

    function handleInstalled() {
        setShowAlert(false);
    }

    useEffect(() => {
        if (!!isIosSafari && !getCookieFromString(cookieKey, document.cookie)) {
            setShowAlert(true);
        }

        window.addEventListener("beforeinstallprompt", handleInstallPrompt);
        window.addEventListener("appinstalled", handleInstalled);

        return () => {
            window.removeEventListener("beforeinstallprompt", handleInstallPrompt);
            window.removeEventListener("appinstalled", handleInstalled);
        }
    }, []);

    let installButton, title;
    if (organizationStore.organization.type === "district") {
        title = organizationStore.organization.title;

        if (isIosSafari) {
            installButton = <button onClick={() => modalStore.addModal({
                type: "iosAppInstallHelp"
            })}>Install</button>
        } else {
            installButton = <button onClick={async () => await deferredPrompt?.current?.prompt()}>Install</button>;
        }
    } else {
        const district = getDistrict(organizationStore.organization);
        title = district.title;
        installButton =
            <ClickableLink href={district.primary_hostname.scheme + "://" + district.primary_hostname.hostname}>Visit
                District to Install</ClickableLink>
    }

    const containerClassName = classNames({
        [styles.container]: true,
        [styles.containerCanInstall]: showAlert && organizationStore.organization.type === "district",
    })

    return <div>
        {showAlert && <div className={containerClassName}>
            <div>
                <button onClick={() => {
                    setShowAlert(false);
                    // since on iOS Safari we seemingly can't determine if inside the app or not, we just want to hide it for good
                    setCookie(cookieKey, "ignore", isIosSafari ? 999999 : 3);
                }}>
                    <FontAwesome name={"fa-times"} size={"2x"} prefix={"fas"}/>
                </button>
            </div>
            <div>
                <h2>{title}</h2>
                <span>Get our free app. It won't take up space on your phone.</span>
            </div>
            <div>
                {installButton}
            </div>
        </div>}
    </div>
}
